import ApiServiceMasterHr from '../apiServiceMasterHr.js';

const querystring = require('querystring')
var VacationService = {

    findAll: function($data) {
        return new Promise(function(resolve, reject) {
            let $options = {};
            $options.url = "vacation"
            $options.method = "get"

            if ($data) {
                $options.url = "vacation?" + querystring.stringify($data)
                console.log($options.url)
            }
            ApiServiceMasterHr.request($options)
            .then(response => {
                console.log('test');
                resolve(response.data.data)
            }).catch(error => {
                reject(error);
            })
        });

    },

    getReportingUser: function($data) {
        return new Promise(function(resolve, reject) {
            let $options = {};
            $options.url = "getReportingUser"
            $options.method = "get"

            if ($data) {
                $options.url = "getReportingUser?" + querystring.stringify($data)
                console.log($options.url)
            }
            ApiServiceMasterHr.request($options)
            .then(response => {
                console.log('test');
                resolve(response.data.data)
            }).catch(error => {
                reject(error);
            })
        });

    },
    getVacationHour: function($data) {
        return new Promise(function(resolve, reject) {
            let $options = {};
            $options.url = "getVacationHour"
            $options.method = "get"

            if ($data) {
                $options.url = "getVacationHour?" + querystring.stringify($data)
                console.log($options.url)
            }
            ApiServiceMasterHr.request($options)
            .then(response => {
                console.log('test');
                resolve(response.data.data)
            }).catch(error => {
                reject(error);
            })
        });

    },
    getChartData: function($data) {
        return new Promise(function(resolve, reject) {
            let $options = {};
            $options.url = "getChartData"
            $options.method = "get"

            if ($data) {
                $options.url = "getChartData?" + querystring.stringify($data)
                console.log($options.url)
            }
            ApiServiceMasterHr.request($options)
            .then(response => {
                console.log('test');
                resolve(response.data.data)
            }).catch(error => {
                reject(error);
            })
        });

    },
    getRequestList: function($data) {
        return new Promise(function(resolve, reject) {
            let $options = {};
            $options.url = "getRequestList"
            $options.method = "get"

            if ($data) {
                $options.url = "getRequestList?" + querystring.stringify($data)
                console.log($options.url)
            }
            ApiServiceMasterHr.request($options)
            .then(response => {
                console.log('test');
                resolve(response.data.data)
            }).catch(error => {
                reject(error);
            })
        });

    },
    getVacationDetails: function($data) {
        return new Promise(function(resolve, reject) {
            let $options = {};
            $options.url = "getVacationDetails"
            $options.method = "get"

            if ($data) {
                $options.url = "getVacationDetails?" + querystring.stringify($data)
                console.log($options.url)
            }
            ApiServiceMasterHr.request($options)
            .then(response => {
                console.log('test');
                resolve(response.data.data)
            }).catch(error => {
                reject(error);
            })
        });

    },

    findOne: function($data) {
        return new Promise(function(resolve, reject) {
            let $options = {};
            $options.url = "vacation/" + $data
            console.log($options.url)
            $options.method = "get"
            if (!$data) {
                $options.data = $data
            }
            ApiServiceMasterHr.request($options)
                .then(response => {
                    // console.log('Gpt the data');
                    resolve(response.data.data)
                }).catch(error => {
                    reject(error);
                })
        });

    },
    update: function($data) {
        return new Promise(function(resolve, reject) {
            let $options = {};
            $options.data = $data
            $options.url = "vacation/" + $data.id;
            $options.method = "put"
            console.log($options)
            ApiServiceMasterHr.request($options)
                .then(response => {
                    resolve(response.data.data)
                }).catch(error => {
                    reject(error)
                });
        })
    },
    save: function($data) {
        return new Promise(function(resolve, reject) {
            var $options = {};
            $options.data = $data
            $options.url = "vacation" + $data.id;
            $options.method = "post"
            console.log($options)
            ApiServiceMasterHr.request($options)
                .then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                });
        });
    },

    create: function($data) {
        return new Promise(function(resolve, reject) {
            var $options = {};
            $options.data = $data
            $options.url = "vacation";
            $options.method = "post"
            console.log($options)
            ApiServiceMasterHr.request($options)
                .then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                });
        });
    }
};
export default VacationService;